import moment from 'moment';

const getError = (error) => {

    if(!error.response){
        console.log(error);
        return;
    }

    if (error.response.status !== 422) {
        return error.response.data.message;
    }
    let result = '';
    const values = Object.values(error.response.data.errors);
    for (const value of values) {
        result += '<span>' + value +  '</span>';
    }
    return result || error.response.data.message;
};
const showNotification = (type,message,notForwarded) => {
    return {type, message, notForwarded};
};
const setHeaders = (state) => {
    return {
        site_id: state.shop
    }
};
const fdate = date => moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY');
const fdateTime = date => moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss');
const fSum = sum => Number(sum).toLocaleString('fr-CA',{minimumFractionDigits: 2});

const all = arr => arr.every(i => i);

const getData = (key,is_numeric = false) => {
    return is_numeric ? Number(sessionStorage.getItem(key)) : sessionStorage.getItem(key);
};
const setData = (key,value) =>{
    return sessionStorage.setItem(key,value);
};
const setPermissions = (data) => {
    sessionStorage.setItem('permissions', JSON.stringify(data))
};
const setMenu = (data) => {
    sessionStorage.setItem('menu', JSON.stringify(data))
};

const setDefaultFilters = (defaults,filters) => {

    let defaultValues = Object.entries(defaults);

    defaultValues.forEach(
        item => {
            filters[item[0]].value = item[1];
        }
    );
    return filters;
};

const utils =  {
    install(Vue) {
        Vue.prototype.$getError = getError;
        Vue.prototype.$showNotification = showNotification;
        Vue.prototype.$setHeaders = setHeaders;
        Vue.prototype.$all = all;
        Vue.prototype.$getData = getData;
        Vue.prototype.$setData = setData;
        Vue.prototype.$setPermissions = setPermissions;
        Vue.prototype.$setMenu = setMenu;

        // Formatting

        Vue.prototype.$fSum = fSum;
        Vue.prototype.$fdate = fdate;
        Vue.prototype.$fdateTime = fdateTime;

        // Misc helpers

        Vue.prototype.$setDefaultFilters = setDefaultFilters;
    }
};

export default utils;